import { Link } from 'react-router-dom'

export function PricingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-primary-700 to-primary-900 text-white px-4 py-12">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="text-primary-100 hover:underline text-sm">
          ← Iniciar sesión / aplicación
        </Link>
        <h1 className="text-3xl font-bold mt-6 mb-2">Planes NetEasyFTTX</h1>
        <p className="text-primary-100 mb-10">
          21 días de prueba con capacidades Pro. Después, plan gratuito básico o suscripción mensual.
        </p>

        <div className="grid gap-6 md:grid-cols-2">
          <div className="bg-white/10 backdrop-blur rounded-2xl p-6 border border-white/20">
            <h2 className="text-xl font-semibold mb-2">Gratis (básico)</h2>
            <p className="text-primary-100 text-sm mb-4">
              Tras la prueba: mapa y edición con límites reducidos (nodos, cables, usuarios). Sin importación/exportación
              masiva ni asistente IA.
            </p>
            <ul className="text-sm space-y-2 list-disc list-inside text-primary-50">
              <li>Diseño FTTH en mapa</li>
              <li>Hasta ~40 nodos / cables (consulta límites en la app)</li>
              <li>1 administrador + 1 usuario adicional</li>
            </ul>
          </div>

          <div className="bg-white text-primary-900 rounded-2xl p-6 shadow-xl">
            <h2 className="text-xl font-semibold mb-2">Pro</h2>
            <p className="text-gray-600 text-sm mb-4">
              Límites amplios, importación/exportación (KML, CSV, informes), colaboración en equipo. Pago vía Stripe
              desde la app (Organización → Uso / plan).
            </p>
            <ul className="text-sm space-y-2 list-disc list-inside text-gray-700">
              <li>Prueba 21 días incluida al registrarte</li>
              <li>Asistente de red con IA (donde esté configurado)</li>
              <li>Portal de facturación Stripe</li>
            </ul>
          </div>
        </div>

        <p className="mt-10 text-sm text-primary-100 flex flex-wrap gap-x-4 gap-y-1">
          <Link to="/about" className="underline">
            Qué es NetEasyFTTX
          </Link>
          <Link to="/soporte" className="underline">
            Soporte y feedback
          </Link>
        </p>
      </div>
    </div>
  )
}
